import React from "react";
import _ErrorBoundary from "./ErrorBoundary";
export { initSentry } from "./sentryInit";
export { withProfiler } from "@sentry/react";

export const ErrorBoundary = _ErrorBoundary;

export const withErrorBoundary = (Component) => {
    return (props) => (
        <ErrorBoundary>
            <Component {...props} />
        </ErrorBoundary>
    );
};
